export enum AvailableCourses {
    KED = "KED",
    PED = "PED",
}